import React from 'react';

import LazySymbol from '../../common/lazy';

const Symbol0375 = React.lazy(() => import('./symbols/0375_screen_analytics_line_graph'));
const Symbol0376 = React.lazy(() => import('./symbols/0376_screen_analytics_line_graph_growth'));
const Symbol0377 = React.lazy(() => import('./symbols/0377_screen_analytics_pie_graph'));
const Symbol0378 = React.lazy(
  () => import('./symbols/0378_analytics_presentation_statistics_graph')
);
const Symbol0379 = React.lazy(() => import('./symbols/0379_business_suitcase'));
const Symbol0380 = React.lazy(() => import('./symbols/0380_line_structure_hierarchy'));
const Symbol0381 = React.lazy(() => import('./symbols/0381_line_structure_relations_hierarchy'));
const Symbol0382 = React.lazy(() => import('./symbols/0382_graph_columns_statistics'));
const Symbol0383 = React.lazy(() => import('./symbols/0383_graph_columns_growth_statistics'));
const Symbol0384 = React.lazy(() => import('./symbols/0384_graph_columns_drop_statistics'));
const Symbol0385 = React.lazy(() => import('./symbols/0385_graph_pie_chart_statistics'));
const Symbol0386 = React.lazy(() => import('./symbols/0386_graph_line_chart_statistics'));
const Symbol0387 = React.lazy(() => import('./symbols/0387_tie_business_man'));
const Symbol0388 = React.lazy(() => import('./symbols/0388_government_white_house_capitol'));
const Symbol0389 = React.lazy(() => import('./symbols/0389_gavel_hammer_law_judge_court'));
const Symbol0390 = React.lazy(() => import('./symbols/0390_scale_justice_law_attorney'));
const Symbol0391 = React.lazy(() => import('./symbols/0391_scale_justice_law_attorney'));
const Symbol0392 = React.lazy(() => import('./symbols/0392_business_idea'));
const Symbol0393 = React.lazy(() => import('./symbols/0393_hand_papers_payment'));
const Symbol0394 = React.lazy(() => import('./symbols/0394_business_handshake_deal_contract_sign'));
const Symbol0395 = React.lazy(() => import('./symbols/0395_analytics_graph_line_statistics'));
const Symbol0396 = React.lazy(() => import('./symbols/0396_analytics_graph_line_statistics_stock'));
const Symbol0397 = React.lazy(
  () => import('./symbols/0397_analytics_graph_line_statistics_presentation_keynote')
);
const Symbol0398 = React.lazy(
  () => import('./symbols/0398_presentation_powerpoint_keynote_meeting')
);
const Symbol0399 = React.lazy(
  () => import('./symbols/0399_meeting_presentation_speech_speaker_keynote')
);
const Symbol0400 = React.lazy(() => import('./symbols/0400_analytics_graph_line_statistics_stock'));
const Symbol0401 = React.lazy(() => import('./symbols/0401_graph_growth_money_stock_inflation'));
const Symbol0402 = React.lazy(() => import('./symbols/0402_stock_money_growth_inflation'));

export interface IProps {}

const Business: React.FC<IProps> = React.memo(() => {
  return (
    <>
      <LazySymbol id="0375_screen_analytics_line_graph" symbol={<Symbol0375 />} />
      <LazySymbol id="0376_screen_analytics_line_graph_growth" symbol={<Symbol0376 />} />
      <LazySymbol id="0377_screen_analytics_pie_graph" symbol={<Symbol0377 />} />
      <LazySymbol id="0378_analytics_presentation_statistics_graph" symbol={<Symbol0378 />} />
      <LazySymbol id="0379_business_suitcase" symbol={<Symbol0379 />} />
      <LazySymbol id="0380_line_structure_hierarchy" symbol={<Symbol0380 />} />
      <LazySymbol id="0381_line_structure_relations_hierarchy" symbol={<Symbol0381 />} />
      <LazySymbol id="0382_graph_columns_statistics" symbol={<Symbol0382 />} />
      <LazySymbol id="0383_graph_columns_growth_statistics" symbol={<Symbol0383 />} />
      <LazySymbol id="0384_graph_columns_drop_statistics" symbol={<Symbol0384 />} />
      <LazySymbol id="0385_graph_pie_chart_statistics" symbol={<Symbol0385 />} />
      <LazySymbol id="0386_graph_line_chart_statistics" symbol={<Symbol0386 />} />
      <LazySymbol id="0387_tie_business_man" symbol={<Symbol0387 />} />
      <LazySymbol id="0388_government_white_house_capitol" symbol={<Symbol0388 />} />
      <LazySymbol id="0389_gavel_hammer_law_judge_court" symbol={<Symbol0389 />} />
      <LazySymbol id="0390_scale_justice_law_attorney" symbol={<Symbol0390 />} />
      <LazySymbol id="0391_scale_justice_law_attorney" symbol={<Symbol0391 />} />
      <LazySymbol id="0392_business_idea" symbol={<Symbol0392 />} />
      <LazySymbol id="0393_hand_papers_payment" symbol={<Symbol0393 />} />
      <LazySymbol id="0394_business_handshake_deal_contract_sign" symbol={<Symbol0394 />} />
      <LazySymbol id="0395_analytics_graph_line_statistics" symbol={<Symbol0395 />} />
      <LazySymbol id="0396_analytics_graph_line_statistics_stock" symbol={<Symbol0396 />} />
      <LazySymbol
        id="0397_analytics_graph_line_statistics_presentation_keynote"
        symbol={<Symbol0397 />}
      />
      <LazySymbol id="0398_presentation_powerpoint_keynote_meeting" symbol={<Symbol0398 />} />
      <LazySymbol id="0399_meeting_presentation_speech_speaker_keynote" symbol={<Symbol0399 />} />
      <LazySymbol id="0400_analytics_graph_line_statistics_stock" symbol={<Symbol0400 />} />
      <LazySymbol id="0401_graph_growth_money_stock_inflation" symbol={<Symbol0401 />} />
      <LazySymbol id="0402_stock_money_growth_inflation" symbol={<Symbol0402 />} />
    </>
  );
});

Business.displayName = 'Business';

export default Business;
